import type { FC } from "react";

import type { MagentoFlavorAttribute } from "@jti/magento-types";

import { StickAttribute } from "./StickAttribute";

import styles from "./StickAttributes.module.scss";

export type StickAttributesProps = {
  attributes: MagentoFlavorAttribute[];
};

export const StickAttributes: FC<StickAttributesProps> = ({ attributes }) => {
  if (!attributes.length) {
    return null;
  }

  return (
    <div className={styles.attributesWrapper}>
      <dl className={styles.attributes} data-testid="flavourAttributes">
        {attributes
          .sort((a, b) => a.sortOrder - b.sortOrder)
          .map((attribute) => (
            <StickAttribute key={attribute.id} {...attribute} />
          ))}
      </dl>
    </div>
  );
};
